import { AppRoutes } from 'AppRoutes';
import { Header } from 'components/Header/Header';
import HelpButton from 'components/HelpButton/help-button';
import { NavBar } from 'components/NavBar/NavBar';
import Alerts from 'components/alerts/alerts';
import ChatPanel from 'components/chat-panel/chat-panel';
import { alertClosed } from 'features/alerts/redux/alerts-slice';
import { useUser } from 'features/users/context/userContext';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import background from './images/background.png';

export const Main = () => {
	const dispatch = useAppDispatch();
	const { isAuthenticated } = useUser();
	const location = useLocation();
	const onHomePage = location.pathname.includes('home');
	const alerts = useAppSelector((state) => state.alerts);
	const [chatOpen, toggleChat] = useState(false);

	return (
		<div
			className={`App ${onHomePage ? 'fixed-size' : ''}`}
			style={{
				backgroundImage: !isAuthenticated ? `url(${background})` : '',
			}}
		>
			<div className='left-container'>
				<NavBar />
			</div>
			<div className={`right-container ${isAuthenticated ? 'user' : ''}`}>
				<Alerts
					alerts={alerts}
					onAlertClose={(id) => dispatch(alertClosed(id))}
					duration={5}
				/>
				<Header />
				<AppRoutes />
				{isAuthenticated && (
					<>
						<HelpButton toggleChat={toggleChat} />
						{chatOpen && <ChatPanel toggleChat={toggleChat} />}
					</>
				)}
			</div>
		</div>
	);
};
